import React from "react";
import EventList from "./EventList";
import EventSlider from "./EventSlider";
import Skeleton from "react-loading-skeleton";
import 'react-loading-skeleton/dist/skeleton.css';
import SkeletonLoader from '../../../devsathan_components/skeletonLoader'


const EventDisplay = ({ events, eventtype, viewType }) => {
  if (!events || events.length === 0) {
    return <SkeletonLoader style={{
      marginTop:'15px'
    }
    }/>
  }

  return (
    <div>
      {viewType === "slider" ? (
        <EventSlider events={events} eventtype={eventtype} />
      ) : (
        <EventList events={events} eventtype={eventtype} />
      )}
    </div>
  );
};

export default EventDisplay;
